import { StyleSheet, Text, View, TouchableOpacity } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import { fontPalette } from '../../../../static/styles/global'

interface MessageData {
  subject: string
  message: string
  messageSentDate?: string
  initiatorType: 'E' | 'A'
  isNew: boolean
}

interface MessagesCardProps {
  messages: {
    messages?: MessageData[]
    data?: {
      count: number
    }
  } | null | undefined
  navigation: any
  t: any
  unreadMessage: any
}

const MessagesCard = ({
  messages,
  navigation,
  t,
  unreadMessage
}: MessagesCardProps): JSX.Element => {

  return (
    <View style={styles.card}>
      {/* Header */}
      <View style={styles.headerRow}>
        <View style={styles.iconTitleContainer}>
          <View style={[styles.iconCircle, { backgroundColor: '#9DD086' }]}>
            <Ionicons name="chatbubble-ellipses" size={16} color="white" />
          </View>
          <Text style={styles.headerTitle}>
            {t('messageslabour')}
            {unreadMessage?.data?.count > 0
              ? ` (${unreadMessage?.data?.count})`
              : ''}

          </Text>
        </View>

        <TouchableOpacity onPress={() => navigation.navigate('CommunicateWithAdmin')}>
          <Text style={styles.viewAllText}>{t('View all')}</Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}

export default MessagesCard

const styles = StyleSheet.create({
  card: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 16,
    marginHorizontal: 16,
    marginVertical: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 8,
    elevation: 2
  },
  headerRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16
  },
  iconTitleContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  iconCircle: {
    width: 28,
    height: 28,
    borderRadius: 14,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8
  },
  headerTitle: {
    fontSize: 16,
    color: '#0B495C',
    fontFamily: fontPalette.primaryBold
  },
  viewAllText: {
    fontSize: 13,
    color: '#9DD086',
    fontFamily: fontPalette.primaryBold
  },
  listContainer: {
    marginTop: 2
  },
  messageItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0'
  },
  avatar: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: '#9DD086',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12
  },
  avatarText: {
    color: 'white',
    fontSize: 13,
    fontWeight: 'bold'
  },
  messageContent: {
    flex: 1
  },
  messageMetaRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 4
  },
  senderName: {
    fontSize: 14,
    fontFamily: fontPalette.primaryBold,
    color: '#222'
  },
  unreadText: {
    color: '#111'
  },
  timeText: {
    fontSize: 11,
    color: '#888'
  },
  messageBody: {
    fontSize: 13,
    color: '#666',
    lineHeight: 16
  },
  emptyText: {
    textAlign: 'center',
    fontSize: 14,
    color: '#777',
    paddingVertical: 12
  }
})
